import "./SignatureCrop.css";
import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { drawImageOnCanvas, generateDownload } from "./Utils";

function SignatureCrop({ imgSrc, handleImage }) {
  const [crop, setCrop] = useState({});
  const [completedCrop, setCompletedCrop] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  const imgRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    console.log("image strc--->", imgSrc);
    if (imgSrc) {
      const objectUrl = URL.createObjectURL(imgSrc);
      setImageUrl(objectUrl);

      // Cleanup function to revoke the object URL
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [imgSrc]);

  const handleCompleteCrop = (crop) => {
    drawImageOnCanvas(imgRef.current, canvasRef.current, crop);
    setCompletedCrop(crop);
    const croppedImageUrl = canvasRef.current.toDataURL();
    if (handleImage) {
      handleImage(croppedImageUrl); // Call the function with the cropped image URL
    }
  };

  const handleDownload = () => {
    generateDownload(canvasRef.current, completedCrop);
  };

  const canvasStyles = {
    width: Math.round(completedCrop?.width ?? 0),
    height: Math.round(completedCrop?.height ?? 0),
  };

  return (
    <div className="SignatureMainDiv">
      <div className="CropperWrapper">
        <ReactCrop
          crop={crop}
          onChange={setCrop}
          aspect={undefined}
          onComplete={handleCompleteCrop}
        >
          {imageUrl && (
            <img
              className="crop-img"
              ref={imgRef}
              src={imageUrl}
              alt="cropper image"
            />
          )}
        </ReactCrop>
        {!imageUrl && <p className="InfoText">Choose file to crop</p>}
        <div className="CanvasWrapper">
          <canvas ref={canvasRef} style={canvasStyles} />
        </div>
      </div>

      <div>
        <button
          type="button"
          disabled={!completedCrop}
          onClick={handleDownload}
          style={{ display: "none" }}
        >
          Download cropped image
        </button>
      </div>
    </div>
  );
}

SignatureCrop.propTypes = {
  imgSrc: PropTypes.instanceOf(File),
  handleImage: PropTypes.func,
};

export default SignatureCrop;
